/* eslint-disable */
// Translation dictionary: en (English) + ht (Haitian Creole / Kreyòl Ayisyen)
export const translations = {
  // Header / Nav
  "nav.services": { en: "Services", ht: "Sèvis" },
  "nav.about": { en: "About", ht: "Sou Nou" },
  "nav.how": { en: "How it Works", ht: "Kijan Sa Mache" },
  "nav.testimonials": { en: "Testimonials", ht: "Temwayaj" },
  "nav.faq": { en: "FAQ", ht: "Kesyon" },
  "nav.brand": { en: "Meaning", ht: "Sans" },
  "nav.chat": { en: "AI Chat", ht: "Chat AI" },
  "nav.portal": { en: "Client Portal", ht: "Pòtal Kliyan" },
  "header.book": { en: "Book Now", ht: "Rezève Konsiltasyon" },
  "header.tagline": { en: "Consulting LLC", ht: "Consulting LLC" },

  // Hero
  "hero.badge": {
    en: "Nurse-Led Fertility Guidance & Support",
    ht: "Gid ak Sipò pou Fètilite — Dirije pa yon Enfimyè",
  },
  "hero.title1": { en: "You are not alone", ht: "Ou pa pou kont ou" },
  "hero.title2": { en: "on your", ht: "nan" },
  "hero.title3": { en: "fertility journey.", ht: "vwayaj fètilite w." },
  "hero.subtitle": {
    en: "Soarlife is a nurse-led fertility guidance and support service in Orlando, Florida. We offer non-medical companionship, education, and advocacy — in person or virtually — so you never have to navigate IVF, IUI, or your fertility journey alone.",
    ht: "Soarlife se yon sèvis gid ak sipò pou fètilite ki dirije pa yon enfimyè nan Orlando, Florida. Nou ofri konpayi, edikasyon, ak defans ki pa medikal — an pèsòn oswa vityèl — pou ou pa janm gen pou navige IVF, IUI, oswa vwayaj fètilite w pou kont ou.",
  },
  "hero.cta.book": { en: "Book Now", ht: "Rezève Konsiltasyon" },
  "hero.cta.contact": { en: "Send a Message", ht: "Voye yon Mesaj" },
  "hero.tag.location": { en: "Orlando, Florida", ht: "Orlando, Florida" },
  "hero.tag.nurse": { en: "Nurse-Led Support", ht: "Sipò Dirije pa Enfimyè" },
  "hero.tag.lang": { en: "English & Haitian Creole", ht: "Anglè & Kreyòl Ayisyen" },
  "hero.tag.format": { en: "Virtual & In-Person", ht: "Vityèl & An Pèsòn" },
  "hero.quote.label": { en: "Founder's Promise", ht: "Pwomès Fondatè a" },
  "hero.quote.text": {
    en: "“Every appointment, every emotion — you'll never face it on your own.”",
    ht: "“Chak randevou, chak emosyon — ou p ap janm fè fas ak li pou kont ou.”",
  },

  // Stats
  "stats.1.value": { en: "Nurse-Led", ht: "Dirije pa Enfimyè" },
  "stats.1.label": { en: "Guidance & Support", ht: "Gid ak Sipò" },
  "stats.2.value": { en: "Orlando", ht: "Orlando" },
  "stats.2.label": { en: "In-Person Service Area", ht: "Zòn Sèvis An Pèsòn" },
  "stats.3.value": { en: "50 US", ht: "50 Eta" },
  "stats.3.label": { en: "Virtual Coverage", ht: "Kouvèti Vityèl" },
  "stats.4.value": { en: "EN · Kreyòl", ht: "EN · Kreyòl" },
  "stats.4.label": { en: "Bilingual Care", ht: "Swen Bileng" },

  // Services
  "services.eyebrow": { en: "Services & Pricing", ht: "Sèvis & Pri" },
  "services.heading.a": { en: "Compassionate support for every", ht: "Sipò ranpli ak konpasyon pou chak" },
  "services.heading.em": { en: "step", ht: "etap" },
  "services.heading.b": { en: "of the fertility journey.", ht: "nan vwayaj fètilite a." },
  "services.intro": {
    en: "All services are non-medical, supportive in nature — education, guidance, and emotional companionship offered alongside your licensed care team. Choose the level of support that fits your moment.",
    ht: "Tout sèvis yo se sèvis sipò ki pa medikal — edikasyon, gid, ak konpayi emosyonèl ki ofri ansanm ak ekip swen lisansye w. Chwazi nivo sipò ki adapte ak moman w.",
  },
  "services.book": { en: "Book this service", ht: "Rezève sèvis sa a" },
  "services.viewAll": { en: "View All Services & Book Now →", ht: "Wè Tout Sèvis Yo & Rezève Konsiltasyon →" },
  "services.label.signature": { en: "Signature Package", ht: "Pakèt Siyati" },

  "svc.ivf.title": { en: "IVF Concierge Package", ht: "Pakèt Konsyèj IVF" },
  "svc.ivf.duration": { en: "2 hr · per cycle", ht: "2 èdtan · pa sik" },
  "svc.ivf.desc": {
    en: "Comprehensive cycle support — from cycle prep to embryo transfer, with personal guidance every step of the way.",
    ht: "Sipò konplè pou sik la — soti nan preparasyon sik la rive transfè anbriyon, ak gid pèsonèl chak etap.",
  },
  "svc.iui.title": { en: "IUI Support", ht: "Sipò IUI" },
  "svc.iui.duration": { en: "1 hr 30 min · per cycle", ht: "1 è 30 min · pa sik" },
  "svc.iui.desc": {
    en: "End-to-end IUI cycle guidance — timing, expectations, and emotional support.",
    ht: "Gid konplè pou sik IUI — moman, atant, ak sipò emosyonèl.",
  },
  "svc.care.title": { en: "Care Coordination Support", ht: "Sipò Kowòdinasyon Swen" },
  "svc.care.duration": { en: "1 hr · per cycle", ht: "1 èdtan · pa sik" },
  "svc.care.desc": {
    en: "Support tailored to your protocol — portal message assistance, interpreting non-medical information, and keeping you organized.",
    ht: "Sipò ki adapte ak pwotokòl ou — èd pou mesaj pòtal, entèpretasyon enfòmasyon ki pa medikal, ak òganizasyon.",
  },
  "svc.comp.title": { en: "Appointment Companion", ht: "Akonpayman Randevou" },
  "svc.comp.duration": { en: "1 hr 45 min", ht: "1 è 45 min" },
  "svc.comp.desc": {
    en: "A calm, informed presence beside you — taking notes, holding space, and helping you ask the questions that matter.",
    ht: "Yon prezans kalm ak enfòme bò kote w — pran nòt, kenbe espas, ak ede w poze kesyon enpòtan yo.",
  },
  "svc.new.title": { en: "New Client Consultation", ht: "Konsiltasyon Nouvo Kliyan" },
  "svc.new.duration": { en: "1 hr", ht: "1 èdtan" },
  "svc.new.desc": {
    en: "Where we begin. A grounded conversation to understand your journey and build your plan.",
    ht: "Kote nou kòmanse. Yon konvèsasyon ki ankre pou konprann vwayaj ou epi bati plan ou.",
  },
  "svc.prep.title": { en: "Doctor Visit Prep", ht: "Preparasyon Vizit Doktè" },
  "svc.prep.duration": { en: "1 hr", ht: "1 èdtan" },
  "svc.prep.desc": {
    en: "Walk into your appointment prepared — with questions, clarity, and confidence.",
    ht: "Antre nan randevou w prepare — ak kesyon, klète, ak konfyans.",
  },
  "svc.med.title": { en: "In-Person Medication Demo", ht: "Demo Medikaman An Pèsòn" },
  "svc.med.duration": { en: "30 min", ht: "30 min" },
  "svc.med.desc": {
    en: "Hands-on, one-to-one teaching for fertility injections — at your pace, in a private setting.",
    ht: "Anseyman dirèk youn-a-youn pou piki fètilite — nan ritm ou, nan yon kote prive.",
  },
  "svc.vmed.title": { en: "Virtual Med Demo", ht: "Demo Medikaman Vityèl" },
  "svc.vmed.duration": { en: "40 min", ht: "40 min" },
  "svc.vmed.desc": {
    en: "Remote injection teaching, anywhere in the U.S. — secure, private, and reassuring.",
    ht: "Anseyman piki adistans, nenpòt kote nan peyi Etazini — an sekirite, prive, ak rasiran.",
  },

  // About
  "about.eyebrow": { en: "Our Story", ht: "Istwa Nou" },
  "about.title.a": { en: "The care I wished", ht: "Swen mwen te swete" },
  "about.title.em": { en: "now offered to you.", ht: "kounye a ofri ba ou." },
  "about.title.b": { en: "I had —", ht: "mwen te genyen —" },
  "about.p1": {
    en: "I never imagined I would walk the path of fertility treatment. Like so many, I believed that when the time came, everything would unfold naturally. But life had other plans, and suddenly I found myself in a world I had never prepared for — a world of medications, monitoring, injections, and endless questions.",
    ht: "Mwen pa t janm imajine mwen ta mache nan chemen tretman fètilite. Tankou anpil moun, mwen te kwè ke lè lè a rive, tout bagay t ap dewoule natirèlman. Men lavi te gen lòt plan, e toudenkou mwen te jwenn tèt mwen nan yon mond mwen pa t janm prepare — yon mond medikaman, swivi, piki, ak kesyon san fen.",
  },
  "about.p2": {
    en: "In those early days of my journey, I realized something deeper than my own struggle: there was a real and painful gap in clear information, meaningful advocacy, and compassionate support. No one prepares you for how overwhelming fertility care can feel — not just physically, but emotionally and mentally.",
    ht: "Nan premye jou vwayaj mwen yo, mwen te reyalize yon bagay ki pi pwofon pase pwòp batay mwen: te gen yon gap reyèl ak doulè nan enfòmasyon klè, defans ki gen sans, ak sipò ki ranpli ak konpasyon. Pèsòn pa prepare w pou jan swen fètilite ka santi w akable — pa sèlman fizikman, men emosyonèlman ak mantalman.",
  },
  "about.p3": {
    en: "Soarlife is the blending of both worlds: my clinical knowledge and my lived journey. It is the care I wished I had — clear, gentle, accessible, and grounded in compassion. I created Soarlife to make your fertility journey easier than mine, softer than mine, and more supported than mine.",
    ht: "Soarlife se melanj de mond yo: konesans klinik mwen ak vwayaj mwen viv la. Se swen mwen te swete mwen te genyen — klè, dous, aksesib, ak ankre nan konpasyon. Mwen kreye Soarlife pou rann vwayaj fètilite w pi fasil pase pa m, pi dous pase pa m, e pi sipòte pase pa m.",
  },
  "about.quote1": {
    en: "No one should have to navigate this path feeling lost or alone. At Soarlife, you are guided, supported, and uplifted — every step of the way.",
    ht: "Pèsòn pa ta dwe oblije navige chemen sa a santi pèdi oswa pou kont li. Nan Soarlife, ou gide, sipòte, ak leve — chak etap nan chemen an.",
  },
  "about.quote2": { en: "Together, we rise. Together, we soar.", ht: "Ansanm, nou leve. Ansanm, nou vole." },
  "about.role": { en: "Founder & Lead Nurse", ht: "Fondatè & Enfimyè Prensipal" },
  "about.pillar1.title": { en: "Nurse-Led Guidance", ht: "Gid Dirije pa Enfimyè" },
  "about.pillar1.text": {
    en: "Soarlife is led by a nurse who walked the fertility path herself — bringing both clinical knowledge and lived experience.",
    ht: "Soarlife dirije pa yon enfimyè ki mache chemen fètilite a li menm — pote konesans klinik ak eksperyans li viv.",
  },
  "about.pillar2.title": { en: "Confidential & Compassionate", ht: "Konfidansyèl & Ak Konpasyon" },
  "about.pillar2.text": {
    en: "Your story is held with respect. We work alongside your licensed clinical team — never around them.",
    ht: "Istwa w respekte. Nou travay ansanm ak ekip klinik lisansye w — pa janm sou kote yo.",
  },
  "about.pillar3.title": { en: "English & Haitian Creole", ht: "Anglè & Kreyòl Ayisyen" },
  "about.pillar3.text": {
    en: "Personalized support delivered in the language that feels most like home — Sevis an Kreyòl e an Anglè.",
    ht: "Sipò pèsonalize delivre nan lang ki santi w pi lakay ou — Sèvis an Kreyòl e an Anglè.",
  },

  // How it works
  "how.eyebrow": { en: "How it Works", ht: "Kijan Sa Mache" },
  "how.title.a": { en: "Care that feels", ht: "Swen ki santi" },
  "how.title.em": { en: "simple,", ht: "senp," },
  "how.title.b": { en: "steady, and yours.", ht: "estab, e ki pou ou." },
  "how.s1.title": { en: "New Client Consultation", ht: "Konsiltasyon Nouvo Kliyan" },
  "how.s1.text": {
    en: "A grounded 1-hour conversation ($100). Tell us where you are in your fertility journey, what feels overwhelming, and what you need support with.",
    ht: "Yon konvèsasyon 1 èdtan ki ankre ($100). Di nou ki kote w nan vwayaj fètilite w, kisa ki santi w akable, ak kisa w bezwen sipò avè l.",
  },
  "how.s2.title": { en: "Personalized Care Plan", ht: "Plan Swen Pèsonalize" },
  "how.s2.text": {
    en: "We build a roadmap together — covering appointments, medications, questions to ask, and emotional checkpoints.",
    ht: "Nou bati yon plan ansanm — ki kouvri randevou, medikaman, kesyon pou poze, ak chèkpwen emosyonèl.",
  },
  "how.s3.title": { en: "Walk Beside You", ht: "Mache Bò Kote W" },
  "how.s3.text": {
    en: "Your nurse joins you at appointments (Orlando in-person or virtual nationwide) and stays available between visits.",
    ht: "Enfimyè w la rejwenn ou nan randevou yo (Orlando an pèsòn oswa vityèl atravè peyi a) e rete disponib ant vizit yo.",
  },

  // Testimonials
  "test.eyebrow": { en: "Words from the Journey", ht: "Pawòl Soti nan Vwayaj la" },
  "test.title.a": { en: "Reflections from those we've", ht: "Refleksyon soti nan moun nou te" },
  "test.title.em": { en: "walked beside.", ht: "mache bò kote yo." },
  "test.virtual": { en: "Virtual Client", ht: "Kliyan Vityèl" },
  "test.1.text": {
    en: "Soarlife was the calm voice in the middle of my IVF storm. Having someone who understood both the medicine and the heartbreak made everything more bearable.",
    ht: "Soarlife te vwa kalm nan mitan tanpèt IVF mwen. Gen yon moun ki te konprann medikaman an ak chagren an te rann tout bagay pi fasil pou pote.",
  },
  "test.2.text": {
    en: "I was terrified of the injections. She walked me through each one — patient, kind, never rushed. By the third night I felt confident.",
    ht: "Mwen te pè piki yo anpil. Li te mache avè m nan chak youn — pasyan, dous, pa janm prese. Nan twazyèm aswè a mwen te santi m konfyan.",
  },
  "test.3.text": {
    en: "Having someone in Haitian Creole who understood our family — that meant the world to my mother. Soarlife made us feel seen.",
    ht: "Gen yon moun an Kreyòl Ayisyen ki te konprann fanmi nou — sa te vle di tout bagay pou manman m. Soarlife fè nou santi nou wè ak konprann.",
  },
  "test.4.text": {
    en: "I had questions I was too embarrassed to ask my doctor. Soarlife gave me space to ask them, then helped me bring them to my next appointment.",
    ht: "Mwen te gen kesyon mwen te wont poze doktè m. Soarlife ban m espas pou poze yo, epi li ede m pote yo nan pwochen randevou m.",
  },
  "test.5.text": {
    en: "After two failed cycles I was emotionally done. The new client consultation re-grounded me. Round three felt completely different — supported.",
    ht: "Apre de sik ki pa t mache, mwen te fini emosyonèlman. Konsiltasyon nouvo kliyan an te re-ankre m. Twazyèm esè a te santi konplètman diferan — sipòte.",
  },
  "test.6.text": {
    en: "She joined our telehealth visit, took the notes my husband and I couldn't, and followed up the next day with a written summary. Worth every penny.",
    ht: "Li te rejwenn vizit telesante nou an, pran nòt mari m ak mwen pa t ka pran yo, epi li swiv nan jou apre a ak yon rezime ekri. Sa vo chak kòb.",
  },

  // Brand meaning
  "brand.eyebrow": { en: "The Meaning Behind the Name", ht: "Sans ki Dèyè Non an" },
  "brand.title.a": { en: "Soarlife was created to inspire", ht: "Soarlife te kreye pou enspire" },
  "brand.title.em": { en: "hope", ht: "espwa" },
  "brand.title.b": { en: "during one of life's most emotional journeys.", ht: "pandan youn nan vwayaj ki pi emosyonèl nan lavi." },
  "brand.soar.text": {
    en: "Represents rising above fear, uncertainty, and infertility challenges — with strength and guidance.",
    ht: "Reprezante depase laperèz, ensetitid, ak defi enfètilite — ak fòs ak gid.",
  },
  "brand.life.text": {
    en: "Represents wellness, healing, family, and the possibility of new beginnings.",
    ht: "Reprezante byennèt, gerizon, fanmi, ak posibilite nouvo kòmansman.",
  },
  "brand.closing.a": { en: "Together,", ht: "Ansanm," },
  "brand.closing.b": {
    en: "reflects a mission to help individuals and couples navigate their fertility journey with support, education, compassion, and empowerment.",
    ht: "reflete yon misyon pou ede moun ak koup navige vwayaj fètilite yo ak sipò, edikasyon, konpasyon, ak pouvwa.",
  },
  "brand.tag.support": { en: "Support", ht: "Sipò" },
  "brand.tag.education": { en: "Education", ht: "Edikasyon" },
  "brand.tag.compassion": { en: "Compassion", ht: "Konpasyon" },
  "brand.tag.empowerment": { en: "Empowerment", ht: "Pouvwa" },

  // FAQ
  "faq.eyebrow": { en: "Frequently Asked", ht: "Kesyon ki Poze Souvan" },
  "faq.title.a": { en: "Everything you may be", ht: "Tout sa ou ka ap" },
  "faq.title.em": { en: "wondering.", ht: "mande tèt ou." },
  "faq.q1": {
    en: "Are you a fertility clinic? Do you give medical advice?",
    ht: "Èske nou se yon klinik fètilite? Èske nou bay konsèy medikal?",
  },
  "faq.a1": {
    en: "No. Soarlife provides non-medical, supportive services only — education, guidance, and emotional support. We do not diagnose, treat, prescribe, or adjust medications. We work alongside your licensed healthcare provider, never in place of them.",
    ht: "Non. Soarlife bay sèvis sipò ki pa medikal sèlman — edikasyon, gid, ak sipò emosyonèl. Nou pa dyagnostike, trete, preskri, oswa ajiste medikaman. Nou travay ansanm ak founisè swen sante lisansye w, pa janm nan plas li.",
  },
  "faq.q2": { en: "Do you only serve clients in Orlando, FL?", ht: "Èske nou sèvi kliyan nan Orlando, FL sèlman?" },
  "faq.a2": {
    en: "In-person appointment accompaniment is offered in the greater Orlando area. Virtual support, treatment navigation, and concierge consultations are available nationwide.",
    ht: "Akonpayman an pèsòn pou randevou yo ofri nan zòn Orlando. Sipò vityèl, navigasyon tretman, ak konsiltasyon konsyèj disponib atravè tout peyi a.",
  },
  "faq.q3": { en: "Can you join a telehealth fertility appointment?", ht: "Èske nou ka rejwenn yon randevou telesante?" },
  "faq.a3": {
    en: "Yes. We routinely join virtual visits — listening in, taking detailed notes, and following up afterward to make sure nothing was missed.",
    ht: "Wi. Nou souvan rejwenn vizit vityèl — koute, pran nòt detaye, e swiv apre pou asire pa gen anyen ki manke.",
  },
  "faq.q4": { en: "What types of fertility treatments do you support?", ht: "Ki kalite tretman fètilite nou sipòte?" },
  "faq.a4": {
    en: "IVF, IUI, egg and embryo freezing, donor cycles, fertility preservation before medical treatment, and general fertility evaluation. We meet you wherever you are in the journey.",
    ht: "IVF, IUI, konjelasyon ze ak anbriyon, sik donatè, prezèvasyon fètilite anvan tretman medikal, ak evalyasyon fètilite jeneral. Nou rankontre w kèlkeswa kote w ye nan vwayaj la.",
  },
  "faq.q5": { en: "Is my information confidential?", ht: "Èske enfòmasyon mwen konfidansyèl?" },
  "faq.a5": {
    en: "Absolutely. We treat every conversation with strict confidentiality and HIPAA-aware standards of care.",
    ht: "Absoliman. Nou trete chak konvèsasyon ak konfidansyalite estrik ak estanda swen ki konsyan HIPAA.",
  },
  "faq.q6": { en: "What does it cost?", ht: "Konbyen sa koute?" },
  "faq.a6": {
    en: "Each service has a clear, published price (visible above on this page) and you can book and pay directly here on our website. Not sure where to start? Begin with a First Consultation ($100, 1 hr) — we'll build your plan together. Please note: all sales are final; appointments can be rescheduled at no charge.",
    ht: "Chak sèvis gen yon pri klè ki pibliye (vizib pi wo sou paj sa a) e ou ka rezève e peye dirèkteman isit sou sit entènèt nou an. Pa konnen kote pou kòmanse? Kòmanse ak yon Premye Konsiltasyon ($100, 1 èdtan) — nou pral bati plan w ansanm. Tanpri sonje: tout lavant yo final; ou ka replanifye randevou gratis.",
  },

  // Disclaimer
  "disc.eyebrow": { en: "Service Agreement & Disclaimer", ht: "Akò Sèvis & Avètisman" },
  "disc.title": { en: "Non-medical, supportive services only.", ht: "Sèvis sipò ki pa medikal sèlman." },
  "disc.p1": {
    en: "This agreement is entered into between Soarlife Consulting LLC (\"the Company\") and any individual receiving services (\"the Client\") on the date services are scheduled.",
    ht: "Akò sa a antre ant Soarlife Consulting LLC (\"Konpayi an\") ak nenpòt moun k ap resevwa sèvis (\"Kliyan an\") nan dat sèvis yo pwograme.",
  },
  "disc.p2": {
    en: "Soarlife Consulting provides non-medical, supportive services only — including education, guidance, and emotional support throughout your fertility journey. We do not diagnose medical conditions, provide treatment, prescribe or adjust medications, or offer medical advice.",
    ht: "Soarlife Consulting bay sèvis sipò ki pa medikal sèlman — ki gen ladan edikasyon, gid, ak sipò emosyonèl pandan tout vwayaj fètilite w. Nou pa dyagnostike kondisyon medikal, bay tretman, preskri oswa ajiste medikaman, oswa ofri konsèy medikal.",
  },
  "disc.intro": { en: "By scheduling and participating in any service, the Client acknowledges and agrees that:", ht: "Lè w pwograme ak patisipe nan nenpòt sèvis, Kliyan an rekonèt e dakò ke:" },
  "disc.b1": { en: "All services are non-medical in nature.", ht: "Tout sèvis yo se sèvis ki pa medikal." },
  "disc.b2": { en: "The information provided is for educational and support purposes only.", ht: "Enfòmasyon yo bay yo se pou edikasyon ak sipò sèlman." },
  "disc.b3": { en: "The Client is responsible for consulting with their licensed healthcare provider for any medical concerns or decisions.", ht: "Kliyan an responsab pou konsilte founisè swen sante lisansye li pou nenpòt enkyetid oswa desizyon medikal." },
  "disc.p3": {
    en: "The Client voluntarily agrees to release and hold harmless Soarlife Consulting LLC from any and all claims, liabilities, or damages arising from the use of these non-medical support services. This agreement is intended to be clear, voluntary, and compliant with Florida guidelines for enforceable waivers.",
    ht: "Kliyan an volontèman dakò pou libere ak pwoteje Soarlife Consulting LLC kont nenpòt reklamasyon, responsablite, oswa domaj ki soti nan itilizasyon sèvis sipò ki pa medikal sa yo. Akò sa a fèt pou klè, volontè, ak konfòm ak direktiv Florida pou egzansyon ki ka aplike.",
  },
  "disc.note": {
    en: "By booking an appointment, you automatically acknowledge and agree to the terms of this agreement.",
    ht: "Lè w rezève yon randevou, ou otomatikman rekonèt e dakò ak tèm akò sa a.",
  },

  // Contact
  "contact.eyebrow": { en: "Send a Message", ht: "Voye yon Mesaj" },
  "contact.title.a": { en: "Let's talk —", ht: "Annou pale —" },
  "contact.title.em": { en: "at your pace.", ht: "nan ritm ou." },
  "contact.intro.a": {
    en: "Share a few details and we'll reach out within one business day to schedule a complimentary 20-minute conversation. No pressure, no obligation.",
    ht: "Pataje kèk detay e nou pral kontakte w nan yon jou ouvrab pou pwograme yon konvèsasyon gratis 20 minit. San presyon, san obligasyon.",
  },
  "contact.intro.link": { en: "Book directly on Square →", ht: "Rezève dirèkteman sou Square →" },
  "contact.svc.accomp": { en: "In-Person Appointment Accompaniment (Orlando)", ht: "Akonpayman Randevou An Pèsòn (Orlando)" },
  "contact.svc.virtual": { en: "Virtual Appointment Support", ht: "Sipò Randevou Vityèl" },
  "contact.svc.nav": { en: "Treatment Navigation", ht: "Navigasyon Tretman" },
  "contact.svc.concierge": { en: "Concierge Consultation", ht: "Konsiltasyon Konsyèj" },
  "contact.svc.med": { en: "Medication & Protocol Education", ht: "Edikasyon sou Medikaman & Pwotokòl" },
  "contact.svc.unsure": { en: "Not sure yet", ht: "Pa sèten ankò" },
  "contact.label.area": { en: "Service Area", ht: "Zòn Sèvis" },
  "contact.val.area": { en: "Orlando, Florida — virtual nationwide", ht: "Orlando, Florida — vityèl atravè tout peyi a" },
  "contact.label.call": { en: "Call", ht: "Rele" },
  "contact.label.text": { en: "Text Only", ht: "Mesaj Tèks Sèlman" },
  "contact.label.email": { en: "Email", ht: "Imèl" },
  "contact.label.name": { en: "Full Name", ht: "Non Konplè" },
  "contact.label.emailField": { en: "Email", ht: "Imèl" },
  "contact.label.phone": { en: "Phone (optional)", ht: "Telefòn (opsyonèl)" },
  "contact.label.service": { en: "Service Interest", ht: "Sèvis ki Enterese W" },
  "contact.placeholder.service": { en: "Select a service…", ht: "Chwazi yon sèvis…" },
  "contact.label.format": { en: "Preferred Format", ht: "Fòma Prefere" },
  "contact.format.virtual": { en: "Virtual", ht: "Vityèl" },
  "contact.format.inperson": { en: "In Person (Orlando)", ht: "An Pèsòn (Orlando)" },
  "contact.format.either": { en: "Either", ht: "Nenpòt" },
  "contact.label.message": { en: "What's on your heart?", ht: "Kisa ki nan kè w?" },
  "contact.placeholder.message": {
    en: "Share where you are in your journey, what you're hoping for, or any questions…",
    ht: "Pataje kote w ye nan vwayaj ou, sa w ap espere, oswa nenpòt kesyon…",
  },
  "contact.submit": { en: "Send Message", ht: "Voye Mesaj" },
  "contact.submitting": { en: "Sending…", ht: "Voye…" },
  "contact.disclaimer": {
    en: "By submitting you agree to be contacted by Soarlife Consulting. We never share your information.",
    ht: "Lè w soumèt, ou dakò pou Soarlife Consulting kontakte w. Nou pa janm pataje enfòmasyon w.",
  },
  "contact.success.title": { en: "Thank you for reaching out.", ht: "Mèsi paske w kontakte nou." },
  "contact.success.text": {
    en: "Your message has landed safely. A nurse will personally respond within one business day.",
    ht: "Mesaj ou rive an sekirite. Yon enfimyè pral reponn pèsonèlman nan yon jou ouvrab.",
  },
  "contact.success.again": { en: "Send another message", ht: "Voye yon lòt mesaj" },

  // Footer
  "footer.tagline": {
    en: "Nurse-led fertility guidance and support based in Orlando, Florida. Compassionate, bilingual care — English & Haitian Creole.",
    ht: "Gid ak sipò fètilite ki dirije pa enfimyè ki baze nan Orlando, Florida. Swen ranpli ak konpasyon, bileng — Anglè & Kreyòl Ayisyen.",
  },
  "footer.explore": { en: "Explore", ht: "Eksplore" },
  "footer.newsletter.label": { en: "Stay in Touch", ht: "Rete an Kontak" },
  "footer.newsletter.intro": {
    en: "Occasional notes on fertility navigation, support, and gentle guidance — never spam.",
    ht: "Nòt ositan sou navigasyon fètilite, sipò, ak gid dous — pa janm spam.",
  },
  "footer.newsletter.placeholder": { en: "Your email", ht: "Imèl ou" },
  "footer.newsletter.submit": { en: "Join", ht: "Jwenn" },
  "footer.newsletter.success": { en: "✓ You're on the list. Welcome.", ht: "✓ Ou sou lis la. Byenveni." },
  "footer.newsletter.error": { en: "Could not sign up. Please try again.", ht: "Pa ka enskri. Tanpri eseye ankò." },
  "footer.book": { en: "Book Now →", ht: "Rezève Konsiltasyon →" },
  "footer.agreement": { en: "Service Agreement", ht: "Akò Sèvis" },
  "footer.contact": { en: "Contact", ht: "Kontakte" },
  "footer.teamlogin": { en: "Team Login", ht: "Koneksyon Ekip" },
  "footer.clinics": { en: "For Clinics", ht: "Pou Klinik" },

  // Watch (ad section)
  "watch.eyebrow": { en: "Watch · 46 seconds", ht: "Gade · 46 segond" },
  "watch.title.a": { en: "See how Soarlife walks", ht: "Gade kijan Soarlife mache" },
  "watch.title.em": { en: "beside you.", ht: "bò kote w." },
  "watch.sub": {
    en: "A quick look at your Fertility Navigator — the portal, your personal roadmap, and the care team behind it.",
    ht: "Yon apèsi rapid sou Navigatè Fètilite w — pòtal la, plan vwayaj pèsonèl ou, ak ekip swen ki dèyè l.",
  },
  "watch.note": { en: "Educational support — not medical advice.", ht: "Sipò edikatif — pa konsèy medikal." },
  "footer.copyright": {
    en: "© {year} Soarlife Consulting LLC — Orlando, Florida. All rights reserved.",
    ht: "© {year} Soarlife Consulting LLC — Orlando, Florida. Tout dwa rezève.",
  },
  "footer.privacy": { en: "Privacy", ht: "Konfidansyalite" },
  "footer.hipaa": { en: "HIPAA Notice", ht: "Avi HIPAA" },
  "footer.terms": { en: "Terms", ht: "Tèm" },

  // Booking flow (/book + /book/manage)
  "book.eyebrow": { en: "Soarlife Consulting", ht: "Soarlife Consulting" },
  "book.title": { en: "Book your appointment", ht: "Rezève randevou w" },
  "book.subtitle": {
    en: "Choose your service, pick a time that works for you, and check out securely. No account needed — your portal access is created for you with support packages.",
    ht: "Chwazi sèvis ou, chwazi yon lè ki bon pou ou, e peye an tout sekirite. Ou pa bezwen kont — nou kreye aksè pòtal ou pou ou ak pakè sipò yo.",
  },
  "book.step1": { en: "Service", ht: "Sèvis" },
  "book.step2": { en: "Date & time", ht: "Dat ak lè" },
  "book.withWhom": { en: "Who would you like to see?", ht: "Ak kilès ou ta renmen wè?" },
  "book.noPreference": { en: "No preference — first available", ht: "Pa gen preferans — premye moun ki disponib" },
  "book.step3": { en: "Your details", ht: "Enfòmasyon w" },
  "book.chooseService": { en: "1 · Choose your service", ht: "1 · Chwazi sèvis ou" },
  "book.pickTime": { en: "2 · Pick a date & time (ET)", ht: "2 · Chwazi yon dat ak yon lè (ET)" },
  "book.includesPortal": { en: "Includes Patient Portal access", ht: "Gen aksè Pòtal Pasyan ladan l" },
  "book.min": { en: "min", ht: "minit" },
  "book.selectDate": { en: "Select a date first", ht: "Chwazi yon dat anvan" },
  "book.loadingTimes": { en: "Loading times…", ht: "N ap chaje lè yo…" },
  "book.noSlots": {
    en: "No availability on this day — please choose another date.",
    ht: "Pa gen disponiblite jou sa a — tanpri chwazi yon lòt dat.",
  },
  "book.details": { en: "3 · Your details", ht: "3 · Enfòmasyon w" },
  "book.name": { en: "Full name", ht: "Non konplè" },
  "book.email": { en: "Email address", ht: "Imel" },
  "book.phone": { en: "Phone (for text reminders)", ht: "Telefòn (pou rapèl pa tèks)" },
  "book.notes": {
    en: "Anything you'd like us to know? (optional)",
    ht: "Gen yon bagay ou ta renmen nou konnen? (si w vle)",
  },
  "book.policyStrong": { en: "All sales are final.", ht: "Tout lavant yo final." },
  "book.policy": {
    en: "I understand that cancellations are non-refundable. If I need to change my appointment, I can reschedule at no charge using the link in my confirmation.",
    ht: "Mwen konprann ke yo pa rembourse anilasyon. Si m bezwen chanje randevou m, mwen ka replanifye l gratis ak lyen ki nan konfirmasyon m.",
  },
  "book.pay": { en: "Pay securely", ht: "Peye an tout sekirite" },
  "book.back": { en: "Back to soarlifeconsulting.com", ht: "Retounen nan soarlifeconsulting.com" },
  "book.errorGeneric": {
    en: "Something went wrong — please try again.",
    ht: "Yon bagay pa t mache — tanpri eseye ankò.",
  },
  "book.upsellText": {
    en: "Planning IUI or IVF? Most families continue into a support package — it includes everything from this consultation, plus your Patient Portal, roadmap, and care team.",
    ht: "W ap planifye IUI oswa IVF? Pifo fanmi kontinye ak yon pakè sipò — li gen ladan l tout bagay konsiltasyon sa a, plis Pòtal Pasyan ou, plan vwayaj ou, ak ekip swen ou.",
  },
  "bm.title": { en: "Your booking", ht: "Randevou w" },
  "bm.subtitle": { en: "Manage or reschedule your appointment", ht: "Jere oswa replanifye randevou w" },
  "bm.policy": {
    en: "Cancellations are non-refundable — but you can reschedule to any open time at no charge.",
    ht: "Yo pa rembourse anilasyon — men ou ka replanifye nan nenpòt lè ki lib gratis.",
  },
  "bm.reschedule": { en: "Reschedule", ht: "Replanifye" },
  "bm.cancel": { en: "Cancel (no refund)", ht: "Anile (pa gen remboursman)" },
  "bm.confirmNew": { en: "Confirm new time", ht: "Konfime nouvo lè a" },
  "bm.back": { en: "Back", ht: "Retou" },
  "bm.cancelWarn": {
    en: "If you cancel, your payment is forfeited and no refund will be issued. Would you like to reschedule instead? It's free.",
    ht: "Si w anile, ou pèdi peman w e yo p ap rembourse w. Ou ta pito replanifye? Se gratis.",
  },
  "bm.yesCancel": { en: "Yes, cancel — I understand", ht: "Wi, anile — mwen konprann" },
  "bm.rescheduleInstead": { en: "Reschedule instead", ht: "Replanifye pito" },
  "bm.pending": { en: "Pending payment", ht: "An atant peman" },
  "bm.noSlots": { en: "No availability this day — pick another.", ht: "Pa gen disponiblite jou sa a — chwazi yon lòt." },
  "bm.notFound": {
    en: "We couldn't find this booking. Please check your confirmation link.",
    ht: "Nou pa jwenn randevou sa a. Tanpri verifye lyen konfirmasyon w.",
  },
  "bm.missingLink": { en: "Missing booking link.", ht: "Lyen randevou a manke." },
  "bm.cancelFail": {
    en: "Could not cancel — please call (407) 374-9834.",
    ht: "Nou pa t ka anile — tanpri rele (407) 374-9834.",
  },
};
